export class MemorizePointsEvaluator {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get completedWordTasks() {
        return this.question.wordTasks.filter(wordTask => wordTask.taskProgress.isTaskCompleted);
    }
    get numberOfCompletedWordTasks() {
        return this.completedWordTasks.length;
    }
    get correctWordTasks() {
        return this.completedWordTasks.filter(wordTask => wordTask.wordTaskEvaluate.isCorrectToCurrentInput);
    }
}
